import { FC, useState } from 'react';
import { ActivityLog, ActivityLogInput } from '../../../graphql/generated/graphql.ts';
import { Button, Divider, Stack } from '@mui/material';
import { ActivityStatusForm } from '../../../components/activity/activity-status-form.tsx';
import { useSnackbar } from '../../../contexts/snackbar.context.tsx';
import { useUpdateActivityStatusMutation } from '../../../graphql/generated/operations/activity.ts';

export interface ActivityReportPageProps {
  activityLog: ActivityLog[];
  onNext: () => void;
}

export const ActivityReportPage: FC<ActivityReportPageProps> = ({ activityLog, onNext }) => {
  const [activityLogInput, setActivityLogInput] = useState<ActivityLogInput[]>(activityLog as ActivityLogInput[]);
  const [update] = useUpdateActivityStatusMutation();
  const { push } = useSnackbar();

  return (
    <Stack spacing={2}>
      {activityLogInput?.map((input, index) => (
        <div key={index}>
          <ActivityStatusForm
            input={input}
            onChange={(updatedInput) => {
              const newLogs = [...activityLogInput];
              newLogs[index] = { ...updatedInput };
              setActivityLogInput(newLogs);
            }}
          />
          <Divider />
        </div>
      ))}

      <Button
        variant="contained"
        onClick={async () => {
          const hasIncomplete = activityLogInput.some((log) => !log.completed);
          if (hasIncomplete) {
            push({
              type: 'error',
              message: 'Please complete the form before continuing'
            });
            return;
          }

          for (const input of activityLogInput) {
            await update({
              variables: {
                input: {
                  activityId: input.activityId,
                  completed: input.completed,
                  day: input.day,
                  period: input.period
                }
              }
            });
          }

          onNext();
        }}
      >
        Save
      </Button>
    </Stack>
  );
};
